import { Navigate } from 'react-router-dom';

export const PublicOnlyRoute = ({ children }) => {
  const token = localStorage.getItem('storycraft_token');
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PublicOnlyRoute;
